import { useNavigate } from "react-router-dom";

import { getLink, trans } from "~/providers/lang";
import { ROUTES } from "~/const";
import { useSeo } from "~/hooks/useSeo";

import "./style.less";

export default function GdprPage() {
	const navigate = useNavigate();

	useSeo({
		title: trans("skelet.title.gdpr"),
		canonical: "gdpr",
	});

	function navigateToUpload() {
		navigate(getLink(ROUTES.upload));
	}

	return <div className="body-background">
		<div className="gdpr-page page-content top-shadow">
			<h1 onDoubleClick={navigateToUpload} className="other-page-title">
				{trans('menu.gdpr')}
			</h1>
			<div className="row">
				<div className="col-md-12">
					<h2>
						{trans('gdpr.title')}
					</h2>
					<p className="desc gdpr" dangerouslySetInnerHTML={{ __html: trans('gdpr.desc') }} />
					<p className="desc" dangerouslySetInnerHTML={{ __html: trans('gdpr.cookie') }} />
				</div>
			</div>
		</div>
	</div>;
}
